import(/* webpackMode: "eager", webpackExports: ["StyrelsenView"] */ "/app/src/sections/presentation/styrelsen/styrelsen-view.tsx");
